import { toast } from "react-toastify";
import {
  creditNoteApproveApi,
  creditNoteBulkActionApi,
  creditNoteCreateApi,
  creditNoteDeleteApi,
  creditNoteUpdateApi,
  getCreditNoteApi,
  invoiceUpdateApi,
} from "../../../../services/api";
import {
  getCreditNoteStatus,
  getCurrentRole,
  getUserDetails,
} from "../../../../services/commonFunction";
import {
  deleteDataFromApi,
  getDataFromApi,
  GetTenantDetails,
  postDataFromApi,
  putDataFromApi,
} from "../../../../services/commonServices";
import { decryptDataForURL } from "../../../../utills/useCryptoUtils";
import { handleCommonUndoLastChanges } from "../UndoApprovalRequestHandler";
export const handleCreateCreditNoteChanges = async (
  formData,
  setIsOverlayLoader,
  navigate,
  type,
  action,
  rejectMark,
) => {
  try {
    const MainData = {
      cn_source_type: formData[0]?.cn_source_type,
      fk_invoice: formData[0]?.fk_invoice,
      fk_customer: formData[0]?.fk_customer,
      cn_reference_invoice_no: formData[0]?.cn_reference_invoice_no,
      cn_credit_inv_type: formData[0]?.cn_credit_inv_type,
      cn_credit_note_no: formData[0]?.cn_credit_note_no,
      cn_title: formData[0]?.cn_title,
      cn_amount: formData[0]?.cn_amount,
      cn_mistack_done_by_type: formData[0]?.cn_mistack_done_by_type,
      cn_mistake_done_reason: formData[0]?.cn_mistake_done_reason,
      cn_mistack_done_by_id:
        formData[0]?.cn_mistack_done_by_type === "USER"
          ? formData[0]?.cn_mistack_done_by_id
          : null,
      cn_status: type == "save" ? "saved" : "pending-2",
      action: type == "save" ? "saved" : "post",
      invoice_amount: formData[0]?.invoice_amount,
      cn_date: formData[0]?.cn_date,
      cn_inv_date: formData[0]?.cn_inv_date,
      gst_amount: formData[0]?.gst_amount || 0,
      cn_salespersonid: formData[0]?.cn_salespersonid,
      cn_is_tally_created: formData[0]?.cn_is_tally_created,
      cn_narration: formData[0]?.cn_narration,
      cn_state: formData[0]?.cn_state,
      cn_gst: formData[0]?.cn_gst,
      cn_tally_branch_code: formData[0]?.cn_tally_branch_code,
    };
    if (parseFloat(MainData.gst_amount) < parseFloat(MainData.cn_amount)) {
      toast.error("Credit note amount cannot be larger than GST amount", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return
    }
    if (['tally-created', 'Completed'].includes(getCreditNoteStatus(formData[0]?.cn_status))) {
      delete MainData.cn_status;
      delete MainData.action;
    }

    setIsOverlayLoader(true);

    let res;
    if (formData[0]?.cn_id) {
      res = await putDataFromApi(
        creditNoteUpdateApi(formData[0]?.cn_id),
        MainData,
      );
    } else {
      res = await postDataFromApi(creditNoteCreateApi, MainData);
    }

    if (res?.data?.status === 200) {
      if (type == "post" && !['Completed', 'tally-created'].includes(getCreditNoteStatus(formData[0]?.cn_status))) {
        handleCommonUndoLastChanges(res?.data?.message, formData[0]?.cn_id || res.data.cn_id, setIsOverlayLoader, navigate, "creditNoteModule", formData)
      }
      else {
        toast.success(res?.data?.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/collections/credit-notes");
      }
    } else {
      toast.error(res?.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  } catch (error) {
    console.error("Credit Note Error:", error);
  } finally {
    setIsOverlayLoader(false);
  }
};

export const handleGetCreditNote = async (
  cn_id,
  setFormData,
  setIsOverlayLoaders,
) => {
  try {
    setIsOverlayLoaders(true);
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.split("?")[1]);
    const action = decryptDataForURL(params.get("status"));
    let res = await getDataFromApi(getCreditNoteApi(cn_id));

    if (res.data.status === 200) {
      setFormData((prevFormData) => {
        return {
          0: {
            ...prevFormData[0],
            ...res?.data.data,
            ["fk_customer"]: res?.data.data.customer_id,
            ["fk_invoice"]: res?.data.data.fk_invoice_id,
          },
        };
      });
    } else {
      toast.error(res.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  } finally {
    setIsOverlayLoaders(false);
  }
};

export const handleApproveRejectCreditNote = async (
  formData,
  setIsOverlayLoader,
  navigate,
  action,
  remark,
) => {
  try {
    if (action === "approve") {
      remark = formData[0]?.remark;
    }
    const MainData = {
      action: action,
      remark: remark,
      cn_mistack_done_by_type: formData[0]?.cn_mistack_done_by_type,
      cn_mistake_done_reason: formData[0]?.cn_mistake_done_reason,
      cn_mistack_done_by_id:
        formData[0]?.cn_mistack_done_by_type === "USER"
          ? formData[0]?.cn_mistack_done_by_id
          : null,
    };

    setIsOverlayLoader(true);

    let res;
    res = await postDataFromApi(
      creditNoteApproveApi(formData[0]?.cn_id),
      MainData,
    );

    if (res?.data?.status === 200) {
      if (action === "approve") {
        handleCommonUndoLastChanges(res?.data?.message, formData[0]?.cn_id, setIsOverlayLoader, navigate, "creditNoteModule", formData)
      }
      else {
        toast.success(res?.data?.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/collections/credit-notes");
      }

    } else {
      toast.error(res?.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  } catch (error) {
    console.error("Credit Note Error:", error);
  } finally {
    setIsOverlayLoader(false);
  }
};

export const checkNextApproval = (nextApproval) => {
  // return 'CU'
  const role = getCurrentRole();
  if (["BU", "LR", "CU"].includes(role)) return role;
  return getUserDetails()?.all_roles?.usr_emp_id_orig || "";
};

export const handleCreditNoteDelete = async (
  creditNoteId,
  setIsDelete,
  getAllListingData,
  setPopupIndex,
) => {
  try {
    let creditNoteDelete = creditNoteDeleteApi(creditNoteId);
    let res = await deleteDataFromApi(creditNoteDelete);
    if (res?.data?.status === 200) {
      toast.success(res.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      getAllListingData();
    } else {
      toast.error(res.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  } catch (ex) {
  } finally {
    setIsDelete(false);
    setPopupIndex(-1);
  }
};

export const handleBulkApprovalHandler = async (setIsOverlayLoader,selectedRows,formData, callback) => {
  try {
    setIsOverlayLoader(true)
    let payload = {
      cn_ids: selectedRows,
      action: 'approve',
      remark:formData[0]?.cn_remark
    }
    let res = await postDataFromApi(creditNoteBulkActionApi, payload);
    if (res?.data?.status === 200) {
      toast.success(res.data.message);
      callback()
    } else {
      toast.error(res?.data?.message || "Failed to Action.");
    }
  } catch (error) {
    console.log('eee', error)
    toast.error("Failed to Action.");
  }
  finally {
    setIsOverlayLoader(false)
  }
}